var _rect, _rect2, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 137,
    viewBox: "0 0 194 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 57.5,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(90 77 57.5)",
    fill: "#F1EDF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 102.5,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(90 171 102.5)",
    fill: "#EB3366"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.5,
    cy: 20,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 162.5 20)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.286 80.0352H59.7141C55.6509 80.0352 52.3569 76.7412 52.3569 72.678V32.2137C52.3569 28.1504 55.6509 24.8566 59.7141 24.8566H133.286C137.349 24.8566 140.643 28.1504 140.643 32.2137V72.678C140.643 76.7412 137.349 80.0352 133.286 80.0352Z",
    stroke: "url(#paint0_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 39.5713C103.611 39.5713 109.375 45.3356 109.375 52.4463C109.375 59.557 103.611 65.3213 96.5 65.3213C89.3893 65.3213 83.625 59.557 83.625 52.4463C83.625 45.3356 89.3893 39.5713 96.5 39.5713Z",
    stroke: "url(#paint1_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.415 50.6066C64.3992 50.6066 63.5757 51.4301 63.5757 52.4459C63.5757 53.4617 64.3992 54.2852 65.415 54.2852",
    stroke: "url(#paint2_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4155 50.6066C66.4313 50.6066 67.2548 51.4301 67.2548 52.4459C67.2548 53.4617 66.4313 54.2852 65.4155 54.2852",
    stroke: "url(#paint3_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.584 50.6066C126.568 50.6066 125.745 51.4301 125.745 52.4459C125.745 53.4617 126.568 54.2852 127.584 54.2852",
    stroke: "url(#paint4_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.585 50.6066C128.6 50.6066 129.424 51.4301 129.424 52.4459C129.424 53.4617 128.6 54.2852 127.585 54.2852",
    stroke: "url(#paint5_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 113.143V98.4283",
    stroke: "url(#paint6_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.893 105.785V91.0709",
    stroke: "url(#paint7_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1069 105.785V91.0709",
    stroke: "url(#paint8_linear_9249_30952)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9249_30952",
    x1: 139.639,
    y1: 52.8982,
    x2: 15.2082,
    y2: -14.1131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9249_30952",
    x1: 109.082,
    y1: 52.6574,
    x2: 67.0285,
    y2: 38.5025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9249_30952",
    x1: 65.3941,
    y1: 52.476,
    x2: 62.142,
    y2: 51.9287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9249_30952",
    x1: 67.2339,
    y1: 52.476,
    x2: 63.9819,
    y2: 51.9287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9249_30952",
    x1: 127.564,
    y1: 52.476,
    x2: 124.311,
    y2: 51.9287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9249_30952",
    x1: 129.403,
    y1: 52.476,
    x2: 126.151,
    y2: 51.9287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9249_30952",
    x1: 97.4886,
    y1: 105.906,
    x2: 95.6714,
    y2: 105.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9249_30952",
    x1: 115.881,
    y1: 98.5486,
    x2: 114.064,
    y2: 98.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9249_30952",
    x1: 79.0956,
    y1: 98.5486,
    x2: 77.2783,
    y2: 98.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestComplete);
export default __webpack_public_path__ + "static/media/invest_complete.32fb89bc8efa57f9c5e3bd4ef4fc8e8b.svg";
export { ForwardRef as ReactComponent };